module.exports = __webpack_public_path__ + "img/郁金香-3.2e35504e.jpg";